import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { PreferencesPort, PresetSet, isEmptyPresetSet } from '@jax-data-science/sci-image-visualizer';
import { PreferencesService } from '../services/preferences.service';

/**
 * Host-side implementation of the visualization library's {@link PreferencesPort}.
 * Delegates to the app's {@link PreferencesService} (jit-service
 * `/api/preferences/annotation-classes`). Bound to the `PREFERENCES_PORT` token
 * in `app.module.ts`, mirroring `RegionIoAdapter` / `REGION_IO_PORT`.
 */
@Injectable({ providedIn: 'root' })
export class PreferencesAdapter implements PreferencesPort {
  constructor(private prefs: PreferencesService) {}

  loadPresetSet(): Observable<PresetSet | null> {
    return this.prefs.getAnnotationClasses().pipe(map((set) => (isEmptyPresetSet(set) ? null : set)));
  }

  savePresetSet(set: PresetSet): Observable<void> {
    return this.prefs.saveAnnotationClasses(set).pipe(map(() => void 0));
  }
}
